module.exports = __webpack_public_path__ + "img/Formosa 1867_4.9dd0de54.jpg";